import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import { Flex, Link, Button } from 'nallian-shared-ui/lib/components';
import apiRoutes from '../../../../app/api/routes';
import IdentificationCodeForm from './IdentificationCodeForm';
import { TABS, ACTIONS } from '../../constants';
import CommunityName from './CommunityName';
import { useCanAccessIdentificationCodes } from '../../hooks/useCanAccessIdentificationCodes';

export const RESOURCE_NAME = 'identificationcode';
export const INFINITE_SCROLL = { loader: 'blocked' };

const IdentificationCodesTable = ({ urlRoot, organisationId }) => {
  const { t } = useTranslation();
  const { action } = useParams();

  const {
    create: canCreateIdCodes,
    delete: canDeleteIdCodes,
    update: canUpdateIdCodes,
  } = useCanAccessIdentificationCodes(organisationId);

  return (
    <>
      {canCreateIdCodes && (
        <>
          <IdentificationCodeForm
            organisationId={organisationId}
            returnRoute={`${urlRoot}/${TABS.IDENTIFICATIONCODES}`}
            open={Boolean(action)}
          />
          <Flex>
            <Link to={`${urlRoot}/identificationcodes/${ACTIONS.NEW}`}>
              <Button btnprimary icon="add" content={t('addIdentificationCode')} />
            </Link>
          </Flex>
        </>
      )}
      <Table
        infiniteScroll={INFINITE_SCROLL}
        resource={RESOURCE_NAME}
        url={addParametersToUri(apiRoutes.identificationCodes(), { organisationId })}
        pageSize={50}
        noUserSettings
        sorted
        filtered
      >
        {canUpdateIdCodes && (
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            url={`${urlRoot}/${TABS.IDENTIFICATIONCODES}/${ACTIONS.EDIT}/:id`}
          />
        )}
        <Params.String
          name="type.name"
          label="identificationCodeType"
          width="20rem"
          minWidth="20rem"
          noFilter
        />
        <Params.String
          name="value"
          label="codeValue"
          width="18rem"
          minWidth="18rem"
          grow
          noFilter
        />
        <Params.Custom
          name="community.name"
          content={CommunityName}
          label="community"
          width="18rem"
          minWidth="18rem"
          grow
          noFilter
        />
        {canDeleteIdCodes && (
          <Menu width="3.5rem" align="center">
            <Actions.Delete
              url={apiRoutes.identificationCodes(':id')}
              label="removeIdentificationCode"
            />
          </Menu>
        )}
      </Table>
    </>
  );
};

IdentificationCodesTable.propTypes = {
  urlRoot: PropTypes.string.isRequired,
  organisationId: PropTypes.string.isRequired,
};

export default IdentificationCodesTable;
